
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 6.25V2H4.75a.748.748 0 00-.75.75v14.5c0 .416.334.75.75.75h10.5c.416 0 .75-.334.75-.75V7h-4.25a.752.752 0 01-.75-.75zm4.781-.969l-3.06-3.062a.75.75 0 00-.53-.219H12v4h4v-.19a.747.747 0 00-.219-.529z","fill":"#999"}})])
          )
        }
      }
    